module.exports = __webpack_public_path__ + "img/Switzerland.466c7547.png";